import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 3l-1 1H5c-.555 0-1 .448-1 1v14c0 .555.448 1 1 1h14c.555 0 1-.448 1-1V9l1-1v11.005A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.892 3 4.997 3H16zm-4.265 11.474c-.214.212-.37.273-.8.404l-.211.062c-.235.067-.466.125-.625.163l-1.578.377.373-1.58a15.775 15.775 0 0 1 .231-.86c.127-.407.192-.57.399-.777L20.246 1.54a1.098 1.098 0 0 1 1.56.01l.632.642a1.101 1.101 0 0 1-.002 1.549l-10.7 10.734zm-.708-.706l10.7-10.734c.038-.038.036-.103-.002-.142l-.632-.643a.099.099 0 0 0-.14-.003L10.23 12.97c-.118.118-.364 1.16-.364 1.16s1.046-.25 1.16-.362z"
});

var SvgInstructions = function SvgInstructions(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgInstructions;